export default __webpack_public_path__ + "static/media/racialEquality.5dc1e285.webp";